import { cn } from '@/lib/utils';

const variants = {
  'on-time': 'status-on-time',
  'late': 'status-late',
  'half-day': 'status-half-day',
  'absent': 'status-absent',
  'pending': 'status-pending',
  'approved': 'status-approved',
  'rejected': 'status-rejected',
  'checked-in': 'status-on-time',
  'checked-out': 'status-approved',
};

const labels = {
  'on-time': 'On Time',
  'late': 'Late',
  'half-day': 'Half Day',
  'absent': 'Absent',
  'pending': 'Pending',
  'approved': 'Approved',
  'rejected': 'Rejected',
  'checked-in': 'Checked In',
  'checked-out': 'Checked Out',
};

export function StatusPill({ status, children, className }) {
  const variant = variants[status] || 'status-pending';
  const label = children || labels[status] || status;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variant,
        className
      )}
      data-testid="attendance-status-pill"
    >
      {label}
    </span>
  );
}
